import React from 'react';
import moment from 'moment';
import {
    Datagrid,
    List, NumberField, ShowButton, TextField, EditButton, useRecordContext, useRefresh, FunctionField,
    RaRecord,
} from 'react-admin';
import {Button, Link} from "@mui/material";
import {Delete} from "@mui/icons-material";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {CustomSnackbarTypes} from "../Common/CustomSnackBar";
import {CookLeavesService} from "../../services/CookLeavesService";
import { LeaveSourceType } from '../../enums/leaveSourceType';
import CallButton from '../Common/CallButton/CallButton';
import { UserType } from '../../enums/common';
import { CookLeaveTypes } from '../../enums/CookLeaveTypes';
import { formatDateTime } from '../../utils/DateTimeUtils';
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const filterFields: CommonFilterField[] = [
    { type: "date", label: "Start Date", source: "startDate" },
    { type: "date", label: "End Date", source: "endDate" },
    {
        type: "select",
        label: "Leave Source",
        source: "leaveSource",
        options: Object.values(LeaveSourceType).map((key) => ({
            value: key,
            label: key,
        })),
    },
    {
        type: "select",
        label: "Leave Type",
        source: "leaveType",
        options: Object.values(CookLeaveTypes).map((key) => ({
            value: key,
            label: key,
        })),
    },
    { type: "text", label: "Phone", source: "cookPhoneNumber" },
    {
        type: "text",
        label: "Cook Id",
        source: "cookId",
        numeric: true,
        // The old NumberInput sent a number — keep the same filter type
        toFilter: (value) => Number(value),
    },
];

const cookLeaveService = new CookLeavesService();

const DeleteButton = (props: any) => {
    let record = useRecordContext();
    let refresh = useRefresh();
    
    return (
        <Button
            variant={'contained'}
            color={'error'}
            size={"small"}
            endIcon={<Delete/>}
            onClick={() => {
                EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                    message: "Are you sure you want to cancel this leave?",
                    onClose: (confirmed: boolean) => {
                        if (confirmed) {
                            cookLeaveService.cancelLeave(record.id as number).then(() => {
                                refresh();
                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: 'Leave Cancelled',
                                    type: CustomSnackbarTypes.SUCCESS
                                });
                            });
                        }
                    },
                    title: "Confirmation"
                });
            }}
        >
            Cancel
        </Button>
    )
}

const CookLeaves = (props: any) => {
    return (
        <List
            {...props}
            sort={{ field: 'id', order: 'DESC' }}
            sx={{
                "& .RaList-content": {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                },
            }}
        >
            <>
            <CommonFilterCard fields={filterFields} />

            <br />

            <StyledDatagridWrapper title="Cook Leaves">
            <Datagrid bulkActionButtons={false} sx={commonDatagridSx}>
                <NumberField source='id'/>
                <FunctionField 
                label="Cook Id" 
                render={(record: RaRecord | undefined) => (
                    <Link href={`/#/Cooks/${record?.cookId}/show`}>
                    {record?.cookId}
                    </Link>
                )} 
                />
                <TextField source='cookFirstName' sortable={false}/>
                <TextField source='cookLastName' sortable={false}/>
                <FunctionField label= "Cook Phone Number" render={(record: any) => <CallButton toPhoneNumber={record?.cookPhoneNumber} userType={UserType.COOK} referenceId={record?.id} referenceModelName="COOK_LEAVES_V3"/>}/>
                <TextField source='leaveType'sortable={false}/>
                <TextField source='leaveSource' sortable={false}/>
                <TextField source='isEmergencyLeave' emptyText="false"/>
                <FunctionField label="leaveStartDate" render={(record: any) => record?.leaveStartDate ? moment(record.leaveStartDate).format('DD MMM YYYY') : '-'} />
                <TextField source='startTime'/>
                <FunctionField label="leaveEndDate" render={(record: any) => record?.leaveEndDate ? moment(record.leaveEndDate).format('DD MMM YYYY') : '-'} />
                <TextField source='endTime'/>
                <FunctionField label="createdAt" render={(record: any) => record?.createdAt ? formatDateTime(record.createdAt) : '-'} />
                <FunctionField label="updatedAt" render={(record: any) => record?.updatedAt ? formatDateTime(record.updatedAt) : '-'} />
                <ShowButton/>
                <EditButton/>
                <DeleteButton/>
            </Datagrid>
            </StyledDatagridWrapper>
            </>
        </List>
    );
};

export default CookLeaves;
